import { FC } from 'react'
import {
  CopyButton,
  Flex,
  GreyGrey80,
  Primary13Regular,
  SettingsFormControl,
  Text
} from '@sequencehq/core-components'

export const AccountIdSettings: FC<{ accountId: string }> = ({ accountId }) => (
  <SettingsFormControl label="Account ID">
    <Flex alignItems="center" gap="8px">
      <Text
        color={GreyGrey80}
        data-testid="settings.accountId.value"
        whiteSpace="nowrap"
        {...Primary13Regular}
      >
        {accountId}
      </Text>
      <CopyButton
        value={accountId}
        enableGroupHover={false}
        data-testid="settings.accountId.copy"
      />
    </Flex>
  </SettingsFormControl>
)
